import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import TimesheetComp from "./Component/TimesheetComp"

const Timesheet =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TimesheetComp />
        </div>
        <Footer />
        </>
    )
}

export default Timesheet